import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const KlachtenApi = {
    saveExterneKlacht(model, documents) {
        const serviceUrl = prependRoot('/klachten/externeKlacht', getApiRoot());
        return axios.put(serviceUrl,
            {
                item: model,
                documenten: documents
            },
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    saveInterneKlacht(model, documents) {
        const serviceUrl = prependRoot('/klachten/interneKlacht', getApiRoot());
        return axios.put(serviceUrl,
            {
                item: model,
                documenten: documents
            },
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    }
};

export default KlachtenApi;